import { File } from '@/components/commons/file.model';
import type { Archivo, EtapaEnum, DmsApi } from '@conacyt/dms-client';
import { ResilientWebPipelineBuilder, TimeSpansInMilliSeconds } from 'resilience-typescript';
import * as Sentry from '@sentry/vue';

const SECRETARIA = 'RIZOMA';
const CLAVE_CONVOCATORIA = 'personas-morales';
const ETAPA: EtapaEnum = 'REGISTRO';
export default class DmsService {
  private proxy = ResilientWebPipelineBuilder.New()
    .useConsoleLogger()
    .useRetry(2, 3) // 3 intentos máximo
    .useTimeout(3, TimeSpansInMilliSeconds.oneMinute)
    .builtToRequestFactory();

  constructor(private dmsApi: DmsApi) {}

  public obtienePdfGuardado(url: string): Promise<any> {
    if (url) {
      this.dmsApi
        .obtenerDocumentoPorUrl(url)
        .then(res => {})
        .catch(err => {});
    } else {
      return Promise.resolve(false);
    }
  }

  public dispatchDocumentoV2(idRegistro: string, pdf: File): Promise<any> {
    if (pdf.content !== null && pdf.content.length > 0) {
      const archivo: Archivo = {
        nombre: pdf.nombre.substring(0, pdf.nombre.lastIndexOf('.')) + new Date().getTime() + '.pdf',
        contenido: pdf.content,
      };
      return this.creaDocumentoResilience(idRegistro, archivo);
    }
  }

  public creaDocumento(id: string, fotografia: File) {
    const archivo: Archivo = { nombre: fotografia.nombre, contenido: fotografia.content };
    this.obtenerDocumentoResilience(id, archivo)
      .then(response => {
        if (response.data.urlPublica != null) {
          this.borraDocumentoResilience(response.data.urlPublica)
            .then(response => {
              this.creaDocumentoResilience(id, archivo);
            })
            .catch(error => {});
        } else {
          this.creaDocumentoResilience(id, archivo);
        }
      })
      .catch(error => {});
  }

  public actualizaDocumento(idRegistro: string, fotografia: File) {
    this.borraDocumentoResilience(fotografia.uri)
      .then(response => {
        const archivo: Archivo = { nombre: fotografia.nombre, contenido: fotografia.content };
        this.obtenerDocumentoResilience(idRegistro, archivo)
          .then(response => {
            if (response.data.urlPublica != null) {
              this.borraDocumentoResilience(response.data.urlPublica)
                .then(response => {
                  this.creaDocumentoResilience(idRegistro, archivo);
                })
                .catch(error => {});
            } else {
              this.creaDocumentoResilience(idRegistro, archivo);
            }
          })
          .catch(error => {});
      })
      .catch(error => {});
  }

  public borraDocumento(url: string): Promise<any> {
    return this.borraDocumentoResilience(url);
  }

  public obtenerDocumentoResilience(id: string, archivo: Archivo): Promise<any> {
    const url = `/services/dmsms/api/documentos/${SECRETARIA}/convocatorias/${CLAVE_CONVOCATORIA}/${id}/${archivo.nombre}/compartido?etapa=${ETAPA}`;
    this.resetProxy();
    return this.proxy.request().get(url).execute<any>();
  }

  public creaDocumentoResilience(id: string, archivo: Archivo): Promise<any> {
    const url = `/services/dmsms/api/documentos/${SECRETARIA}/convocatorias/${CLAVE_CONVOCATORIA}/${id}?etapa=${ETAPA}`;
    this.resetProxy();
    return this.proxy.request().post(url).withBody(archivo).execute<any>();
  }

  public borraDocumentoResilience(url: string): Promise<any> {
    url = `/services/dmsms/api/documentos?urlCompartida=${url}`;
    this.resetProxy();
    return this.proxy.request().delete(url).execute<any>();
  }

  public resetProxy(): void {
    this.proxy.maintenance().cache().clear();
    this.proxy.maintenance().circuitBreaker().resetErrorCount();
    this.proxy.maintenance().circuitBreaker().close();
  }

  public eliminaDocumento(uri: string): void {
    this.borraDocumento(uri)
      .then(res => {})
      .catch(err => {
        Sentry.captureException(err + ' NO se elimino documento: ' + uri);
      });
  }
}
